/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import React, { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import MainView from '../view/MainView'
import MenuStore from '../store/MenuStore'
import SessionStore from '../store/SessionStore'
import LoginAction from '../action/login'

class MainContainer extends Component {
  static getStores() {
    return [MenuStore, SessionStore]
  }

  static calculateState(prevState, props) {
    return {
      menu: MenuStore.getState(),
      session: SessionStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    // ログインチェック
    LoginAction.checkStatus()
  }

  render() {
    return MainView(this.state)
  }
}

export default withRouter(Container.create(MainContainer, { withProps: true }))
